<template>
  <div
    v-if="aspect"
    class="box"
  >
    <svg
      width="100"
      :height="aspect * 100"
      class="size-helper"
    />
    <div class="box-content">
      <slot />
    </div>
  </div>
  <template v-else>
    <slot />
  </template>
</template>

<script lang="ts" setup>
defineProps(
  {
    aspect: { type: Number },
    useHeight: { type: Boolean, default: false },
  },
);
</script>

<style lang="scss" scoped>
.box {
  position: relative;
  height: v-bind('useHeight ? "100%": "auto"');

  .size-helper {
    width: v-bind('useHeight ? "auto" : "100%"');
    height: v-bind('useHeight ? "100%": "auto"');
  }

  .box-content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
